import React, { useState, useEffect } from "react";
import {
  Container,
  CircularProgress,
  Typography,
  IconButton,
  Grid,
  Box,
  Badge,
  Link,
  Tooltip,
  Button,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
  CopyHHContract,
  FetchGetContractDocumentListById,
} from "../api/contractVersionService";
import toast from "react-hot-toast";
import { DataGrid } from "@mui/x-data-grid";
import "../App.css";
import ConfirmationDialog from "../confirm/confirmation";
import { ACTION, STATUS } from "../utils/commonConstant";
import ContractMarkelApproveRejectPopupModal from "../ModelPopup/ContractMarkelApproveRejectPopup";
import HeaderLogo from "../components/LogoHeader";
import { fetchFromWebApi } from "../utils/fetchFromWebApi";

const ContractVersion = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [elements, setElements] = useState([]);

  const { clientId, contractVersionId } = useParams();
  const navigate = useNavigate();
  const [openPreview, setOpenPreview] = useState(false);

  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    id: false,
  });
  const [rows, setRows] = useState([]);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [actionType, setActionType] = useState(null);
  const [commentDialogOpen, setCommentDialogOpen] = useState(false); // State for dialog
  const [formData, setFormData] = useState({
    comment: "",
    markelName: "",
  });
  const [markelError, setMarkelError] = useState({
    markelName: false,
    errorMessage: "",
  });
  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 50,
      headerClassName: "bold-header",
    },
    {
      field: "VersionName",
      headerName: "Version Name",
      width: 300,
      align: "center",
      headerAlign: "center",
      headerClassName: "bold-header",
      renderCell: (params) => (
        <Tooltip title="Please click to preview" arrow>
          <Link
            href={`#`}
            underline="hover"
            sx={{
              color: "text.primary",
              "&:hover": {
                color: "primary.main",
              },
            }}
            onClick={(e) => {
              e.preventDefault(); // Prevent default link behavior
              handleVersionNameClick(params.row); // Call your click handler
            }}
          >
            {params.value}
          </Link>
        </Tooltip>
      ),
    },
    {
      field: "TemplateName",
      headerName: "Template Name",
      width: 200,
      align: "center",
      headerAlign: "center",
      headerClassName: "bold-header",
    },
    {
      field: "Status",
      headerName: "Status",
      width: 200,
      align: "center",
      headerAlign: "center",
      headerClassName: "bold-header",
      renderCell: (params) => (
        <Badge
          color={getBadgeColor(params.row.Status)}
          badgeContent={params.row.Status}
        />
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 300,
      sortable: false,
      align: "center",
      headerClassName: "bold-header",
      headerAlign: "center",
      renderCell: (params) => (
        <Box>
          <Tooltip title="Approve" arrow>
            <IconButton
              color="success"
              aria-label="Approve"
              onClick={() =>
                //handelConfirmOpen(STATUS.APPROVED, params.row)
                handleVersionNameClick(params.row)
              }
              sx={{
                backgroundColor: "lightblue",
              }}
            >
              <CheckIcon color="success" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Reject" arrow>
            <IconButton
              color="info"
              aria-label="Reject"
              onClick={() =>
                //handelConfirmOpen(STATUS.REJECTED, params.row)
                handleVersionNameClick(params.row)
              }
              sx={{
                backgroundColor: "lightblue",
              }}
            >
              <CloseIcon color="error" />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];
  const fetchData = async () => {
    try {
      const result = await FetchGetContractDocumentListById(contractVersionId);
      setData(result);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };
  const addIdToData = (data) => {
    return data.map((item) => ({ ...item, id: item.Id }));
  };

  useEffect(() => {
    fetchData();
  }, [contractVersionId]);

  useEffect(() => {
    const updatedRows = addIdToData(data);
    setRows(updatedRows);
  }, [data]);

  if (loading) {
    return (
      <Container>
        <CircularProgress />
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <Typography color="error">
          Error fetching data: {error.message}
        </Typography>
      </Container>
    );
  }

  const getAllComments = (elements) => {
    const commentClass = document.querySelectorAll(".selection-highlight");
    const newComments = [];
    elements.forEach(element => {
      var tcComments = element.props.trackChangesComments;
      if (tcComments && Object.keys(tcComments).length !== 0) {
        Object.keys(tcComments).forEach(key => {
          let changes = tcComments[key];
          changes?.forEach(change => {
            if (change.userRole && (change.userRole == 'Markel')) {
              newComments.push(change);
            }
          })
        });
      }
    });
    return commentClass.length + newComments.length ?? 0;
  };

  const handleAction = async (actionType, elements, comment, markelName) => {
    console.log("ELEMENTS FROM HANDLEACTION", elements)
    try {
      const res = await fetchFromWebApi(
        `HHContract/MarkelApproveRejectContractDocument`,
        {
          method: "POST",
          body: JSON.stringify({
            contractVersionId: contractVersionId,
            isApproved: actionType === STATUS.APPROVED ? true : false,
            comment: comment,
            userId: localStorage.getItem("UserId"),
            markelName: markelName,
            metaData: elements,
            noOfComments: getAllComments(elements)
          }),
        }
      );
      setLoading(false);
      if (res?.ok) {
        toast.success(`Contract ${actionType} successfully!`);
        fetchData();
        setElements([]);
        navigate(`/contract/${clientId}/${data[0].HHDocumentId}`);
      } else {
        console.error("Failed to save form:", await res.text());
        toast.error("Failed to sign contract:", await res.text());
      }
    } catch (error) {
      setLoading(false);
      toast.error(`Failed to ${actionType} contract.`);
    }
  };
  const handelConfirmOpen = async (actionType, row) => {
    if (actionType === ACTION.DOWNLOAD) {
      const baseURL = `${window.location.protocol}//${window.location.host}`;
      const pdfDownloadUrl = `${process.env.REACT_APP_HHMANAGER_AWS_LAMBDA_PDF_URL}/?url=${baseURL}/${clientId}/download/${row.Id}`;
      window.open(pdfDownloadUrl, "_blank");
    } else {
      if (actionType === STATUS.APPROVED) {
        const trackChangeelements = document.querySelectorAll(
          ".track-changes"
        );

        for (const element of trackChangeelements) {
          if (element.dataset.status === "Created") {
            const spanElement = document.querySelector(`span[data-change-id="${element.dataset.changeId}"]`);
            if (spanElement) {
              spanElement.scrollIntoView({ behavior: "smooth", block: "center" });
            }
            toast.error(
              "Client does not resolved all track changes. Please wait for client approval."
            );

            return;
          }
          else if (element.dataset.status === "Pending") {
            const spanElement = document.querySelector(`span[data-change-id="${element.dataset.changeId}"]`);
            if (spanElement) {
              spanElement.scrollIntoView({ behavior: "smooth", block: "center" });
            }
            let errorMessage = element.dataset.actionType.toLowerCase() === 'rejected' ? 'Form cannot be approved due to rejected comments.' : 'Please resolve all track changes before proceeding.'
            toast.error(errorMessage);
            return;
          }
        }
      }
      setActionType(actionType);
      setSelectedRow(row);
      setConfirmDialogOpen(true);
      console.log("ELEMENTS UPDATED FRO ", elements)
    }
  };
  const handleMenuOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const handleEdit = () => {
    handleMenuClose();
  };

  const handleCopyContract = async () => {
    console.log("Update Status:", selectedRow);
    const resp = await CopyHHContract(selectedRow.Id);
    console.log("handleActivateContract :", resp);
    handleMenuClose();
    fetchData(); // Refresh data after update
    toast.success("Contract is copied successfully.");
  };

  const handleBack = async () => {
    navigate(`/contract/${clientId}/${data[0].HHDocumentId}`);
    // window.history.back();
  };
  const handleVersionNameClick = (row) => {
    setElements(row.MetaData);
    setSelectedRow(row);
    setOpenPreview(true);
  };
  const handleClosePreview = () => {
    setOpenPreview(false);
    setElements([]);
    setSelectedRow(null);
  };
  const handleCommentIconClick = () => {
    setCommentDialogOpen(true); // Open the dialog
  };

  const handleCommentDialogClose = () => {
    setCommentDialogOpen(false); // Close the dialog
    setFormData({
      comment: "",
      markelName: "",
    });
    setMarkelError({
      markelName: false,
      errorMessage: "",
    });
  };

  const handleCommentSubmit = () => {
    console.log("Comment:", formData.comment);
    if (actionType === STATUS.REJECTED && !formData.comment.trim()) {
      toast.error("Comment is mandatory if the document is rejected.");
      return;
    }
    if (!formData.markelName) {
      setMarkelError({
        markelName: true,
        errorMessage: "Markel Name is required",
      });
      return;
    }
    handleAction(
      actionType,
      elements,
      formData.comment,
      formData.markelName
    );
    handleCommentDialogClose();
    if (openPreview) {
      handleClosePreview();
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });

    if (name === "markelName" && value) {
      setMarkelError({ markelName: false, errorMessage: "" });
    }
  };

  const handleCloseConfirmationDialog = () => {
    setConfirmDialogOpen(false);
  };
  const confirmToggle = async () => {
    debugger;
    if (actionType && selectedRow) {
      setConfirmDialogOpen(false);
      setCommentDialogOpen(true);
    }
  };
  const getBadgeColor = (status) => {
    switch (status) {
      case "Approved":
        return "success";
      case "Pending":
        return "warning";
      case "Rejected":
        return "error";
      default:
        return "default";
    }
  };
  return (
    <>
      <Box sx={{ padding: 2 }}>
        <HeaderLogo clientId={clientId} />
        <Container>
          <Grid
            container
            justifyContent="flex-end"
            alignItems="center"
            mb={2}
            spacing={2}
          >
            <Grid item>
              <Button variant="contained" color="primary" onClick={handleBack}>
                Back
              </Button>
            </Grid>
          </Grid>
          <Paper>
            <h3>Approve/Reject</h3>
            <DataGrid
              rows={rows}
              columns={columns}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 10,
                  },
                },
              }}
              pageSizeOptions={[10, 50, 100]}
              disableSelectionOnClick // Disable row selection
              columnVisibilityModel={columnVisibilityModel}
              onColumnVisibilityModelChange={(newModel) =>
                setColumnVisibilityModel(newModel)
              }
            />
          </Paper>
        </Container>

        <ContractMarkelApproveRejectPopupModal
          open={openPreview}
          onClose={handleClosePreview}
          elements={elements}
          handleConfirmOpen={handelConfirmOpen}
          selectedRow={selectedRow}
          clientId={clientId}
          setElements={setElements}
        />
        <ConfirmationDialog
          open={confirmDialogOpen}
          onClose={handleCloseConfirmationDialog}
          onConfirm={confirmToggle}
          message={`Are you sure you want to [ ${actionType} ] ${selectedRow?.VersionName} Contract Document ?`}
        />

        <Dialog
          open={commentDialogOpen}
          onClose={handleCommentDialogClose}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Write a Comment</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="comment"
              name="comment"
              label="Comment"
              type="text"
              fullWidth
              multiline
              rows={5}
              value={formData.comment}
              onChange={handleInputChange}
              placeholder="Write your comment here..."
            />
            <TextField
              autoFocus
              margin="dense"
              id="markelName"
              name="markelName"
              label="Markel Name"
              type="text"
              fullWidth
              value={formData.markelName}
              onChange={handleInputChange}
              error={markelError.markelName}
              helperText={
                markelError.markelName ? markelError.errorMessage : ""
              }
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCommentDialogClose} color="primary">
              Cancel
            </Button>
            <Button onClick={handleCommentSubmit} color="primary">
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </>
  );
};

export default ContractVersion;
